import { css } from '@emotion/core';
import { aNormalize, variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
import { expandClickZone } from '../common.style';
var colour = variables.colour,
  font = variables.font,
  global = variables.global;
var Size = {
  large: {
    width: 486,
    height: 384
  },
  small: {
    width: 324,
    height: 258
  }
};
var getSize = size => Size[size] || Size.large;
export var listingCard = _ref2 => {
  var size = _ref2.size;
  return /*#__PURE__*/css("width:", getSize(size).width, "px;height:", getSize(size).height, "px;flex-shrink:0;position:relative;:before{position:absolute;top:0;left:0;height:18%;width:100%;background-image:linear-gradient( to bottom,rgba(0,0,0,0.4),rgba(0,0,0,0) );content:'';z-index:", global.layerOverlay, ";}:after{position:absolute;bottom:0;left:0;height:50%;width:100%;background-image:linear-gradient( to bottom,rgba(0,0,0,0),rgba(0,0,0,0.6) );content:'';z-index:", global.layerOverlay, ";}");
};
export var image = {
  name: "122y91a",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;"
};
export var infoSection = /*#__PURE__*/css("position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;z-index:", global.layerOverlay + 1, ";padding:15px;");
export var title = /*#__PURE__*/css("position:absolute;top:15px;left:15px;color:", colour.white, ";font-family:", font.headingFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", font.smallFontSize, ";border-bottom:2px solid ", colour.white, ";width:fit-content;z-index:", global.layerOverlay + 1, ";");
var _ref = {
  name: "1kuy7z7",
  styles: "font-size:14px;"
};
export var listingInfo = _ref3 => {
  var size = _ref3.size;
  return /*#__PURE__*/css("display:flex;flex-direction:column;color:", colour.white, ";", typography.bodyNoLinks, " ", size === 'small' && _ref, ";line-height:", size === 'large' ? '28' : '20', "px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;");
};
export var price = _ref4 => {
  var size = _ref4.size;
  return /*#__PURE__*/css(typography.headingS, " line-height:", size === 'large' ? '28' : '22', "px;");
};
export var addressContainer = /*#__PURE__*/css(aNormalize, " display:flex;flex-direction:column;", expandClickZone);
var addressWrap = {
  name: "1d0tddh",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
};
export var addressLine1 = /*#__PURE__*/css(addressWrap);
export var addressLine2 = _ref5 => {
  var size = _ref5.size;
  return /*#__PURE__*/css(addressWrap, " max-width:", getSize(size).width - 175, "px;");
};
export var agentInfo = {
  name: "70vq4s",
  styles: "position:absolute;right:15px;display:flex;flex-direction:row;align-items:center;gap:5px;"
};
export var agentPhoto = {
  name: "kn46u7",
  styles: "width:48px;height:48px;"
};
export var agencyLogo = {
  name: "13btmrt",
  styles: "max-width:125px;height:25px;object-fit:contain;"
};
export var featureGroup = {
  name: "knzbj2",
  styles: "display:flex;flex-direction:row;gap:10px;"
};
export var feature = {
  name: "1szb2xj",
  styles: "display:flex;gap:5px;align-items:center;"
};
export var featureText = _ref6 => {
  var size = _ref6.size;
  return /*#__PURE__*/css(size === 'large' ? typography.bodyBold : typography.bodySmallBold, " line-height:28px;");
};